module.exports = __webpack_public_path__ + "img/Image campagne kkbb.5857e0dc.png";